import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { transformDepositData } from "modules/paymentManagement/utils";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { successToast } from "../../../../views/pages/manage/common/utils/methods/toasterFunctions/function";
import { getFilterDate } from "modules/paymentManagement/approvalDashboard/shared/constant";

export const getCashLocations = async ({ pageNo, businessAreasAccess,paymentType,  pageSize, ...filters }) => {
  const cashUrl = `${endpoint.cashManagement.cashDashboard.list}?offset=${pageNo}&pageSize=${pageSize}`;
  console.log("businessAreasAccess",paymentType)
  const chequeUrl = `${endpoint.cashManagement.chequeDashboard.list}?offset=${pageNo}&pageSize=${pageSize}`;
 const url = paymentType ==='CHEQUE' ? chequeUrl : cashUrl;
  const request = {...filters,paymentType }
  if(request?.businessAreas?.length === 0|| !request?.businessAreas?.length){
    request['businessAreas'] = businessAreasAccess.map(item=>item.value)
  }
  const  response = await fetchAllPostPromisedData(url, request);
  return {
    rows: (response?.data?.paginatedData||[]).map(item=>transformDepositData(item)) ?? [],
    total: response?.data?.totalRecords ?? 0,
    totalPages:response?.data?.totalPage ?? 0,
  };
};


export const downloadCashReport = async (filters, paymentType = "CASH")=>{
const cashUrl = `${endpoint.cashManagement.cashDashboard.downloadReport}`;
const chequeUrl = `${endpoint.cashManagement.chequeDashboard.downloadReport}`;
 const url = paymentType ==='CHEQUE' ? chequeUrl : cashUrl; 
    try {
         const response =    await fetchAllPostPromisedData(url, {...filters, startDate:getFilterDate(filters?.startDate,'start'),endDate:getFilterDate(filters?.endDate,'end')});
          if(response?.code === 200){
            successToast(response?.data?.notificationStatusMessage || "Report generation initiated successfully");
            return response.data;
          } 

    } catch (error) {
      
    }
        
}

export const getChequeExtensionHistory = async (referenceNumber) => {
  try {
    const req = await fetchAllPromisedData(`${endpoint.chequeManagement.dateExtension.audit}/${referenceNumber}`);
    return req;
  }
  catch (err) {
    console.error(err);
    return null;
  }
}